import React from 'react';
import { styled } from '@mui/system';

const Description = styled('span')(({ theme }) => ({
  color: '#0000008a',
  fontSize: 12,
  marginRight: 16,
  [theme.breakpoints.down('sm')]: {
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'pre',
    paddingLeft: 4,
    marginRight: 0
  }
}));

const AutocompleteServiceFieldDescription = ({ description }) => (
  <Description>
    {description}
  </Description>
);

export default AutocompleteServiceFieldDescription;
